<template>
    <div class="teamStatsSmall">
        <div class="statsCardLabel mb-4">
            <p class="stats-card-header">{{ translations.season }}</p>
            <div class="selectDiv">
                <select v-model="currentSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                    <option v-for="(season) in cardStats.seasons.teamStatistics" :value="season.id">
                        20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap flex-lg-nowrap">
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.red_card }}</div><div class="stats-card-header" :key="redCard">{{ redCard }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-lg-4">
                <div class="stats-card-header">{{ translations.yellow_card }}</div><div class="stats-card-header" :key="yellowCard">{{ yellowCard }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.red_card_game }}</div><div class="stats-card-header" :key="redCardGame">{{ redCardGame }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between">
                <div class="stats-card-header">{{ translations.yellow_card_game }}</div><div class="stats-card-header" :key="yellowCardGame">{{ yellowCardGame }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'card-stats',
    props: {
        cardStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },

    },
    data: function () {
        return {
            currentSeason: this.cardStats.seasons.currentSeason.id,
        }
       
    },
    
    computed: {
        redCard() {
            return this.cardStats.seasons.teamStatistics[this.currentSeason].red_cards.value
        },
        yellowCard() {
            return this.cardStats.seasons.teamStatistics[this.currentSeason].yellow_cards.value
        },
        redCardGame() {
            return +(this.cardStats.seasons.teamStatistics[this.currentSeason].red_cards.value/this.cardStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed).toFixed(2)
        },
        yellowCardGame() {
            return +(this.cardStats.seasons.teamStatistics[this.currentSeason].yellow_cards.value/this.cardStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed).toFixed(2)
        },
    },

    mounted: function () {

        console.log(this.cardStats)
        // console.log(this.playerStats)
        // console.log(this.translations)
    },
}

</script>